<div class="donation-row" (click)="navigate()">
    <div fxFlex="calc(100% - 40px)" fxLayoutAlign="space-around center">
        <div
            *ngIf="!hiddenFilters.includes('donatorSearch')"
            id="name"
            class="donation-row-cell"
            [matTooltip]="donation | donationEntryDonatorName"
            [fxFlex]="(100 / visibleSpans) * spans[0]"
        >
            <div class="name">{{ donation | donationEntryDonatorName }}</div>
        </div>
        <div
            *ngIf="!hiddenFilters.includes('donationSum')"
            [fxFlex]="(100 / visibleSpans) * spans[1]"
            [matTooltip]="donation.amount | numberToPrice"
            class="donation-row-cell"
            id="amount"
        >
            <div class="name amount">{{ donation.amount | numberToPrice }}</div>
        </div>
        <div
            *ngIf="!hiddenFilters.includes('date')"
            class="donation-row-cell"
            [matTooltip]="donation.date | dateToFullDateString"
            [fxFlex]="(100 / visibleSpans) * spans[2]"
            id="date"
        >
            <div class="name">{{ donation.date | dateToFullDateString }}</div>
        </div>

        <div
            *ngIf="!hiddenFilters.includes('channel')"
            [fxFlex]="(100 / visibleSpans) * spans[3]"
            class="donation-row-cell"
            [matTooltip]="donation.channelName ?? ''"
            id="channel"
        >
            <div class="name">{{ donation.channelName | nullToString }}</div>
        </div>
        <div
            *ngIf="!hiddenFilters.includes('projects')"
            [fxFlex]="(100 / visibleSpans) * spans[4]"
            class="donation-row-cell"
            [matTooltip]="donation.actionName ?? ''"
            id="action"
        >
            <div class="name">{{ donation.actionName | nullToString }}</div>
        </div>

        <div
            *ngIf="!hiddenFilters.includes('tags')"
            class="donation-row-cell"
            [fxFlex]="(100 / visibleSpans) * spans[5]"
            [matTooltip]="donation.tags?.join(',') ?? ''"
            id="tags"
        >
            <div class="name">{{ donation.tags?.length ? donation.tags?.join(',') ?? '-' : '-' }}</div>
        </div>

        <div
            *ngIf="!hiddenFilters.includes('permanentDonation')"
            class="donation-row-cell"
            [matTooltip]="donation.permanentDonation ? 'Dauerspende' : 'Einzelspende'"
            [fxFlex]="(100 / visibleSpans) * spans[6]"
            fxLayout="row"
            fxLayoutAlign="start center"
            id="permanentDonation"
        >
            <mat-icon>{{ donation.permanentDonation ? 'file_copy' : 'insert_drive_file' }}</mat-icon
            >{{ donation.permanentDonation ? 'Dauerspende' : 'Einzelspende' }}
        </div>

        <div
            *ngIf="!hiddenFilters.includes('type')"
            class="donation-row-cell"
            id="type"
            [matTooltip]="donation.type | donationType"
            [fxFlex]="(100 / visibleSpans) * spans[7]"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <div class="name">{{ donation.type | donationType }}</div>
        </div>

        <div
            *ngIf="!hiddenFilters.includes('hasDonator')"
            class="donation-row-cell"
            [fxFlex]="(100 / visibleSpans) * spans[8]"
        >
            <div
                class="circle"
                [matTooltip]="donation.hasDonator ? 'Zugeordnet' : 'Nicht zugeordnet'"
                [class.active]="donation.hasDonator"
                id="hasDonator"
            ></div>
        </div>

        <div
            *ngIf="!hiddenFilters.includes('paid')"
            class="donation-row-cell"
            [fxFlex]="(100 / visibleSpans) * spans[9]"
        >
            <div
                class="circle status"
                [matTooltip]="donation.paymentStatus !== donationPaymentStatus.PENDING ? 'Bezahlt' : 'Ausstehend'"
                [class.active]="donation.paymentStatus !== donationPaymentStatus.PENDING"
                id="paymentStatus"
            ></div>
        </div>

        <div
            *ngIf="!hiddenFilters.includes('hasReceipt')"
            class="donation-row-cell"
            [fxFlex]="(100 / visibleSpans) * spans[10]"
            id="receipt"
        >
            <div
                [matTooltip]="donation.receipt | dateToFullDateString"
                style="text-align: center"
                *ngIf="donation.receipt"
            >
                {{ donation.receipt | dateToFullDateString }}
            </div>
            <div
                [matTooltip]="'Nicht ausgestellt'"
                class="circle"
                *ngIf="!donation.receipt"
                id="receipt-second-child"
            ></div>
        </div>
        <div
            *ngIf="!hiddenFilters.includes('purposeName')"
            [fxFlex]="(100 / visibleSpans) * spans[11]"
            class="donation-row-cell"
            [matTooltip]="donation.purposeName ?? ''"
            id="purposeName"
        >
            <div class="name">{{ donation.purposeName | nullToString }}</div>
        </div>
    </div>
    <div fxFlex="50px" fxLayout="row" fxLayoutAlign="end center">
        <button
            *ngIf="!donation.hasDonator"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="menu"
            mat-icon-button
        >
            <mat-icon>more_vert</mat-icon>
        </button>
    </div>
</div>
<div class="line"></div>

<mat-menu #menu="matMenu">
    <div fxLayout="row" fxLayoutAlign="start center" style="cursor: pointer" (click)="deleteDonation()">
        <mat-icon>delete</mat-icon> Löschen
    </div>
</mat-menu>
